import { createContext, useContext } from 'react';

export type AuthState = { isTenantLogin: boolean; isUserLogin: boolean };
export type SetAuthState = React.Dispatch<React.SetStateAction<AuthState | undefined>>;
export const AuthContext = createContext<{ authState: AuthState; setAuthState: SetAuthState }>({
  authState: { isTenantLogin: false, isUserLogin: false },
  setAuthState: () => {},
});
export const useAuthContext = () => useContext(AuthContext);
